export enum LoadType {
    ENLINEA = 'enlinea',
    PROGRAMADA = 'programada'
}